export const getGroupDataPermissionsSelector = state => state?.groups?.get('groupDataPermissions')

export const getGroupActionPermissionsSelector = state =>
  state?.groups?.get('groupActionPermissions')

export const getGroupSelector = state => state?.groups?.get('group')
